module.exports = __webpack_public_path__ + "static/media/mail-sent.72f6930a.svg";